import React, { useState } from 'react'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import './Spoiler.scss';

interface SpoilerProps{
    opened?: boolean
    children: any,
    title: string
}

const Spoiler = (props: SpoilerProps) => {
    const [open, setOpen] = useState(!!props.opened)
  return (
    <div className={'spoiler ' + (open ? 'active' : '')}>
        <div className="spoiler-visible" onClick={() => setOpen(!open)}>
            <span className="spoiler__title">{props.title}</span>
            <span className="spoiler__arrow">
                <KeyboardArrowDownIcon sx={{width: 12, height: 12}}/>
            </span>
        </div>
        <div className={"spoiler-hidden"}>
            {props.children}
        </div>
    </div>
  )
}

export default Spoiler